// All runtime config comes from VITE_* env vars, set per stage at build time.
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? "https://dev.api.smartsafiri.tz/api/v1";
export const DRIVER_APP_URL = import.meta.env.VITE_DRIVER_APP_URL ?? "https://smartsafiri.tz";
export const SUPPORT_PHONE = import.meta.env.VITE_SUPPORT_PHONE ?? "";
export const SUPPORT_EMAIL = import.meta.env.VITE_SUPPORT_EMAIL ?? "support@smartsafiri.tz";
